import React, { useRef } from 'react'
import { showErrorToast } from '../../constToast/constToast';
import { Button, IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { useUploadFileMutation } from '../../store/api/uploadApi';

export default function UploadPhotoVendor({ setUrl, setIsDeleted, label, setLogoPost, typeAttachment }) {

  const [postData, { data: postedData, }] = useUploadFileMutation()
  const inputRef = useRef(null);

  const handleUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const filenameParts = file.name.split('.');
      const fileExtension = filenameParts[filenameParts.length - 1].toLowerCase();

      if (file.size > 2 * 1024 * 1024) {
        showErrorToast('File size cannot be larger than 2 MB.');
        return;
      } else if (
        fileExtension !== 'png' &&
        fileExtension !== 'jpg' &&
        fileExtension !== 'jpeg'
      ) {
        showErrorToast('Please upload a PNG, JPG, or JPEG file.');
        return;
      } else {
        setIsDeleted(false);

        const imageURL = URL.createObjectURL(file);
        setUrl(imageURL);


        ///////////////

        const formData = new FormData()
        formData.append('module', 'Vendors')
        formData.append('files', file)
        postData(formData)

        const logo = {
          attachmentId: 0,
          name: file?.name,
          sourceId: 0,
          sourceTypeId: 3,
          reference: null,
          extensionType: "image/png",
          attachmentTypeId: 0,
          attachmentSubTypeId: 0,
          lastModifiedDate: "0001-01-01T00:00:00",
          size: file?.size,
          file: null,
          fileLink: postedData?.data?.[0],
          type: typeAttachment
        }
        setLogoPost(logo)

      }
    }
  };

  const handleDelete = () => {
    setUrl('');
    setIsDeleted(true)
    inputRef.current.value = "";
  }
  return (
    <>
      <Button variant="contained" component="label">
        {label}
        <input ref={inputRef} hidden accept="image/*" type="file" onChange={handleUpload} />
      </Button>

      <IconButton variant="contained" component="label" onClick={handleDelete}>
        <Delete sx={{ color: 'red' }} />
      </IconButton>
    </>
  )
}
